import { useEffect, useState } from 'react';
import axios from 'axios';
import { Button } from '../components/ui/button';
import { PostCard } from '../components/PostCard';
import { NewsletterBox } from '../components/NewsletterBox';
import { FearGreedWidget } from '../components/FearGreedWidget';
import { BitcoinCalculator } from '../components/BitcoinCalculator';
import { Sidebar } from '../components/Sidebar';
import { ArrowRight, BookOpen, Newspaper, Wrench } from 'lucide-react';
import { Link } from 'react-router-dom';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Home = () => {
  const [news, setNews] = useState([]);
  const [tutorials, setTutorials] = useState([]);
  const [articles, setArticles] = useState([]);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const [newsRes, tutorialsRes, articlesRes] = await Promise.all([
          axios.get(`${API}/articles?category=news&limit=3`),
          axios.get(`${API}/articles?category=tutorial&limit=3`),
          axios.get(`${API}/articles?category=article&limit=3`)
        ]);
        setNews(newsRes.data);
        setTutorials(tutorialsRes.data);
        setArticles(articlesRes.data);
      } catch (error) {
        console.error('Error fetching content:', error);
      }
    };
    fetchContent();
  }, []);

  return (
    <div className="min-h-screen">
      <section className="relative h-[640px] flex items-center justify-center overflow-hidden" data-testid="hero-section">
        <div className="absolute inset-0">
          <img
            src="https://images.unsplash.com/photo-1771791814257-a28bfbae5032?crop=entropy&cs=srgb&fm=jpg&q=85"
            alt="Bitcoin"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-br from-slate-950/90 via-slate-900/70 to-slate-950/80" />
        </div>

        <div className="relative max-w-7xl mx-auto px-4 md:px-8 lg:px-12 text-left">
          <h1 className="text-5xl md:text-7xl font-black tracking-tight leading-[0.92] mb-6 text-white">
            Bitcoin Atlas
          </h1>
          <p className="text-lg md:text-xl leading-relaxed text-slate-300 max-w-2xl mb-10">
            Seu guia completo para navegar o mundo do Bitcoin. Aprenda sobre autocustódia, privacidade, Lightning Network e ferramentas descentralizadas.
          </p>


          <div className="flex flex-wrap gap-4">
            <Link to="/comece-aqui">
              <Button className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-full px-8 py-3 font-bold uppercase tracking-wide shadow-lg shadow-primary/20" data-testid="cta-start-button">
                Comece Aqui <ArrowRight className="ml-2" size={20} />
              </Button>
            </Link>
            <Link to="/doar">
              <Button variant="secondary" className="rounded-full px-8 py-3 font-medium" data-testid="cta-donate-button">
                Apoie o Projeto
              </Button>
            </Link>
          </div>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-16">
          <div className="lg:col-span-2 space-y-16">
            <section data-testid="news-section">
              <div className="flex items-center justify-between mb-8">
                <div className="flex items-center gap-3">
                  <Newspaper className="text-primary" size={32} />
                  <h2 className="text-3xl md:text-4xl font-bold tracking-tight">Últimas Notícias</h2>
                </div>
                <Link to="/noticias" className="text-primary hover:underline font-medium">
                  Ver todas
                </Link>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-6">
                {news.map((article) => (
                  <PostCard key={article.id} article={article} baseUrl="/noticias" />
                ))}
              </div>
            </section>

            <section data-testid="tutorials-section">
              <div className="flex items-center justify-between mb-8">
                <div className="flex items-center gap-3">
                  <BookOpen className="text-primary" size={32} />
                  <h2 className="text-3xl md:text-4xl font-bold tracking-tight">Tutoriais em Destaque</h2>
                </div>
                <Link to="/tutoriais" className="text-primary hover:underline font-medium">
                  Ver todos
                </Link>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-6">
                {tutorials.map((article) => (
                  <PostCard key={article.id} article={article} baseUrl="/tutoriais" />
                ))}
              </div>
            </section>

            <section data-testid="articles-section">
              <div className="flex items-center justify-between mb-8">
                <div className="flex items-center gap-3">
                  <Wrench className="text-primary" size={32} />
                  <h2 className="text-3xl md:text-4xl font-bold tracking-tight">Artigos Recentes</h2>
                </div>
                <Link to="/artigos" className="text-primary hover:underline font-medium">
                  Ver todos
                </Link>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-6">
                {articles.map((article) => (
                  <PostCard key={article.id} article={article} baseUrl="/artigos" />
                ))}
              </div>
            </section>

            <section>
              <NewsletterBox />
            </section>
          </div>

          <div>
            <div className="lg:sticky lg:top-24 space-y-6">
              <FearGreedWidget />
              <BitcoinCalculator />
              <Sidebar />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;